import store from '../store';
import ContactModel from "../models/ContactModel";
import GroupModel from "../models/GroupModel";
import {SearchModel, SearchModelBlock, SearchModelBlockItem} from "../models/SearchModel";
import { json2xml } from 'xml-js'

export default class Search {
  constructor(api) {
    this.api = api
  }

  list() {
    this.api.call_busy({
      '_class': 'Search',
      '_method': 'list',
    }).then(response => {
      // TODO: validation
      let searches = response
      searches = searches.query
        ? (
          searches.query.length
            ? searches.query.map(a => a._attributes)
            : [searches.query._attributes]
        )
        : []
      store.commit('setSearches', searches)
    })
  }

  // --- helpers for load()
  _getField(type, id) {
// console.log('_getField', type, id)
    let pref
    switch (type) {
      case 'field':
      case 'identifier':
        type = 'fields'
        pref = 'i'
        break
      case 'catlist':
        type = 'categories'
        pref = 'c'
        break
      case 'free':
        type = 'custom_fields'
        pref = 'f'
        break
      case 'notice':
        id = type
        type = 'additional_fields'
        pref = 'a'
        break
    }
// console.log(type, id, this.data[type].find(a => a.id == id))
    let fField = store.getters.data[type] ? store.getters.data[type].find(a => a.id == id) : null
    return fField ? {
      ...fField,
      value: `${pref}${id}` // alter value so the v-select/v-autocomplete component can show all items (prevent duplicate IDs)
    } : null
  }

  _getCompare(group, id) {
// console.log('_getCompare', group, id)
    const compares = require('../config/compares.json')
// console.log(compares[group].find(a => a.id == id))
    return compares[group] && Array.isArray(compares[group]) ? compares[group].find(a => a.id == id) : null
  }

  // --- helpers for create(), update() and extended_search()

  _parseSearchToXml() {
    const jsonObject = {
      request: this.buildSearchBlockToJS()
    }
    return json2xml(jsonObject, {compact: true, spaces: true})
  }

  buildSearchBlockToJS() {
    const jsonObject = { search_block: [] }
    let mSearch = store.getters.mSearch
    mSearch.blocks.forEach(block => {
      const sBlock = { search: [] }
      jsonObject.search_block.push(sBlock)
      block.searches.forEach(search => {
        const sSearch = (
          search.field.type === 'free' ?
            { value: [], _attributes: { id: search.field.id, type: search.field.type, name: search.field.label, operator: search.compare.id }}
            :
            (
              search.field.datatype === 'catlist' ?
                { value: [], _attributes: { id: search.field.id, type: search.field.datatype, name: search.field.label, operator: search.compare.id }}
                :
                (
                  search.field.type === 'notice' ?
                    { value: [], _attributes: { type: search.field.type, operator: search.compare.id }}
                    :
                    { value: [], _attributes: { id: search.field.id, type: search.field.type, operator: search.compare.id }}
                )
            )
        )
        sBlock.search.push(sSearch)

        if (search.field.datatype === 'date') {
          const date = search.date.year + (
            search.date.month
              ? search.date.month + (
              search.date.day
                ? search.date.day + (
                search.date.hour
                  ? search.date.hour + (
                  search.date.minute
                    ? search.date.minute
                    : ''
                )
                  : ''
              )
                : ''
            )
              : ''
          )
          // search.values.push(date)
          // search.values.forEach(value => {
          //   this._parseSearchToJSValue({ sSearch, field: search.field, value })
          // })
          search.values = [this._parseSearchToJSValue({ sSearch, field: search.field, value: date })]
        } else if ((search.field.datatype == 'select' || search.field.datatype == 'catlist') && !search.field.multiple) {
            if (Array.isArray(search.values)) {
              search.values = search.values.pop()
            }
          this._parseSearchToJSValue({ sSearch, field: search.field, value: search.values })
        } else if ((search.field.datatype == 'checkbox') && !search.field.multiple) {
          search.values = search.compare.id;
          this._parseSearchToJSValue({ sSearch, field: search.field, value: search.values })
        } else {
          // standard field || select(multiple) || cat(multiple)
          // if (search.field.datatype == 'country') {
          //   this._parseSearchToJSValue({ sSearch, field: search.field, value: search.values })
          // } else {
            if (!Array.isArray(search.values)) {
              search.values = [search.values]
            }
            search.values.forEach(value => {
              this._parseSearchToJSValue({ sSearch, field: search.field, value })
            })
          // }
        }
          // if ((search.field.datatype != 'select' && search.field.datatype != 'catlist') || search.field.multiple) {
          //   if (!Array.isArray(search.values)) {
          //     search.values = [search.values]
          //   }
          //   search.values.forEach(value => {
          //     this._parseSearchToJSValue({ sSearch, field: search.field, value })
          //   })
          // } else {
          //   if (Array.isArray(search.values)) {
          //     search.values = search.values.pop()
          //   }
          //   this._parseSearchToJSValue({ sSearch, field: search.field, value: search.values })
          // }
      })
    })
// console.log(jsonObject)
    return jsonObject
  }

  _parseSearchToJSValue({ sSearch, field, value }) {
    if (field.datatype !== 'checkbox' && !value ) {
      return
    }
    let name = ''
    if (field.datatype === 'catlist') {
      const category = store.getters.data.categories.find(a => a.id == field.id)
      if (category && category.children) {
        const cat = category.children.find(a => a.id == value)
        if (cat) {
          name = this.escapeXml(cat.name)
        }
      }
      if (!sSearch.cat) {
        sSearch.cat = []
      }
      sSearch.cat.push({ _attributes: { id: value, name }})
    } else {
      if (field.datatype === 'checkbox') {
        sSearch.value.push({
          _attributes: { dim_it_encoding: 'base64'},
          _text: 'MQ=='
          // _text: value === 'equals' ? 'MQ==' : 'MA=='  // fixed to "1", search controlled by operator
        })
      } else {
        sSearch.value.push({
          _attributes: { dim_it_encoding: 'base64', name},
          _text: window.btoa(unescape(encodeURIComponent(value)))
        })
      }
    }
  }

  escapeXml(unsafe) {
    return unsafe.replace(/[<>&'"]/g, function (c) {
        switch (c) {
            case '<': return '&lt;';
            case '>': return '&gt;';
            case '&': return '&amp;';
            case '\'': return '&apos;';
            case '"': return '&quot;';
        }
    });
  }

  // loadSearch
  load(id) {
    this.api.call_busy({
      '_class': 'Search',
      '_method': 'load',
      'id': id
    }).then(response => {
// console.log(response)
      let mSearch = new SearchModel(false)
      mSearch.name = response.query._attributes.name
      mSearch.count = response.mailings._attributes.count
      mSearch.item = id
      mSearch.own = (response.query._attributes.user_id == response._attributes.user_id) || store.getters.is_admin
      let mBlocks = []
      let xSearchBlocks = response.query.search_block
      if (!xSearchBlocks.length) {
        xSearchBlocks = [xSearchBlocks]
      }
      for (let xBlock of xSearchBlocks) {
        // TODO: only ONE element necessary, regardles if array or not
        if (!xBlock.length) {
          xBlock = [xBlock]
        }
        if (xBlock.length) {
          xBlock = xBlock.shift()
        }
        let xBlockItems = xBlock.search
        if (!xBlockItems.length) { xBlockItems = [xBlockItems] }

        let mBlock = new SearchModelBlock()

        for (let xBlockItem of xBlockItems) {
          let mBlockItem = new SearchModelBlockItem()

          mBlockItem.field = this._getField(xBlockItem._attributes.type, xBlockItem._attributes.id)
          if (mBlockItem.field) {
            mBlockItem.compare = this._getCompare(mBlockItem.field.datatype, xBlockItem._attributes.operator)
            if (xBlockItem.value) {
              if (mBlockItem.field.datatype === 'date') {
                if (xBlockItem.value.length) {
                  xBlockItem.value = xBlockItem.value.shift()
                }
                let date = xBlockItem.value._text
                mBlockItem.date.year = date.substr(0, 4)
                mBlockItem.date.month = date.substr(4, 2)
                mBlockItem.date.day = date.substr(6, 2)
                mBlockItem.date.hour = date.substr(8, 2)
                mBlockItem.date.minute = date.substr(10, 2)
              } else {
                let values
                if (mBlockItem.field.datatype !== 'select' || mBlockItem.field.multiple || mBlockItem.field.datatype == 'country') {
                  if (!xBlockItem.value.length) {
                    xBlockItem.value = [xBlockItem.value]
                  }
                  values = []
                  for (let xItemValue of xBlockItem.value) {

                    if (xItemValue._text) {
                      values.push(xItemValue._text)
                    }
                  }
                } else {
                  if (xBlockItem.value.length) {
                    xBlockItem.value = xBlockItem.value.shift()
                  }
                  values = xBlockItem.value._text
                }
                mBlockItem.values = values
              }
            }
            else
            if (xBlockItem.cat) {
              if (!xBlockItem.cat.length) {
                xBlockItem.cat = [xBlockItem.cat]
              }
              let values = []
              for (let searchBlockItemCat of xBlockItem.cat) {
                values.push(searchBlockItemCat._attributes.id)
              }
              mBlockItem.values = values
            }
          }
          mBlock.searches.push(mBlockItem)
        }
        mBlocks.push(mBlock)
      }
      mSearch.blocks = mBlocks
      store.commit('setMSearch', mSearch)
    })
  }

  // createSearch
  // TODO: add support for folder_id
  create(name, type='search', folder=null) {
    const xml = this._parseSearchToXml()

    // return
// console.log(name, type)
    if (folder && folder.own) {
      return this.api.call_busy({
        '_class': 'Search',
        '_method': 'create',
        'name': name,
        'xml': xml,
        'type': type,
        'folder_id': folder.id,
      }).then(res => {
        this._post_create(res, name, type)
        return res
      })
    } else {
      return this.api.call_busy({
        '_class': 'Search',
        '_method': 'create',
        'name': name,
        'xml': xml,
        'type': type,
      }).then(res => {
        this._post_create(res, name, type)
        return res
      })
    }
  }

  _post_create(response, name, type) { // eslint-disable-line no-unused-vars
    if (type === 'search') {
      let mSearch = store.getters.mSearch
      mSearch.id = response.query._attributes.id
      mSearch.user_id = response.query._attributes.user_id
      mSearch.user_name = response.query._attributes.user_name
      mSearch.type = response.query._attributes.type
      mSearch.folder_id = response.query._attributes.folder_id
      mSearch.count = 0
      mSearch.item = mSearch.id
      mSearch.own = true
      store.commit('setMSearch', mSearch)
    } else {
      // TODO: store in groupItem
    }
    let searches = store.getters.getSearches
    const search = {
      datatype: type,
      icon: 'mdi-magnify',
      id: response.query._attributes.id,
      key: 's'+response.query._attributes.id,
      label: response.query._attributes.name,
      name: response.query._attributes.name,
      own: true,
      type: response.query._attributes.type,
      folder_id: response.query._attributes.folder_id,
      user_id: response.query._attributes.user_id,
      user_name: response.query._attributes.user_name,
    }
    searches.push(search)
    store.commit('setSearches', searches)
  }

  // updateSearch
  update(name) {
    let mSearch = store.getters.mSearch
    const id = mSearch.item
    const xml = this._parseSearchToXml()
    return this.api.call_busy({
      '_class': 'Search',
      '_method': 'update',
      'id': id,
      'xml': xml,
      'name': name
    }).then(response => {
      let searches = store.getters.getSearches
      const index = searches.findIndex(a => a.id === id)
      if (index >= 0) {
        let search = searches[index]
// console.log(search)
        search.label = name
        search.name = name
        searches[index] = search
// console.log(searches)
        store.commit('setSearches', searches)
      }
      return response
    })
  }

  rename(id, name) {
    return this.api.call_busy({
      '_class': 'Search',
      '_method': 'update',
      'id': id,
      'name': name
    })
  }

  moveSearch(id, folder_id) {
    return this.call(this.url, {
      '_ticket': this.user().ticket,
      '_class': 'Search',
      '_method': 'move',
      'oid': this.user().oid,
      'id': id,
      'folder_id': folder_id
    })
  }

  // inUseSearch
  is_in_use(id) {
    return this.api.call_busy({
      '_class': 'Search',
      '_method': 'is_in_use',
      'id': id
    }).then(response => {
      let searchIsInUse = response.mailings && response.mailings._attributes && response.mailings._attributes.count ? response.mailings._attributes.count > 0 : false
      store.commit('setSearchIsInUse', searchIsInUse)
      let searchUsedInMailings = response.mailings.mailing ? (response.mailings.mailing.length ? response.mailings.mailing : [response.mailings.mailing]) : []
      searchUsedInMailings = searchUsedInMailings.map(a => a._attributes)
      store.commit('setSearchUsedInMailings', searchUsedInMailings)
    })
  }
  // deleteSearch
  delete(id) {
    return this.api.call_busy({
      '_class': 'Search',
      '_method': 'delete',
      'id': id
    }).then(response => {
      if (response._attributes.id) {
        let searches = store.getters.getSearches
        searches = searches.filter(a => a.id !== response._attributes.id)
        store.commit('setSearches', searches)
        return searches
      }
    })
  }

  move(id, folder_id) {
    return this.api.call_busy({
      '_class': 'Search',
      '_method': 'move',
      'id': id,
      'folder_id': folder_id
    }).then(response => {
      return response
    })
  }

  simple_search({search_string, sort='name asc', page=0, rows=20}) {
    return this.api.call_busy({
      '_class': 'Search',
      '_method': 'simple_search',
      'search_string': search_string,
      'page': page,
      'rows': rows,
      'sort': `${sort} nulls last`,
      // 'id_only': 1 // requests ID only (for refresh current search)
    }).then(response => {
      const items = []
// console.log(response)
      if (response.aitem) {
        if (!response.aitem.length) {
          response.aitem = [response.aitem]
        }
        for (let i in response.aitem) {
          items.push(new ContactModel().mapAitem(response.aitem[i]))
        }
        store.commit('setContactsTotal', parseInt(response._attributes.num, 10))
      } else {
        store.commit('setContactsTotal', 0)
      }
// console.log('simple_search: ', items.length)
      store.commit('setContactItems', items)
      return items
    })
  }

  // runSearch
  extended_search({search_id, isUnsavedXml, sort='name asc', page=0, rows=20}) {


    if (search_id || isUnsavedXml) {
      const reqParams = {
        '_class': 'Search',
        '_method': 'extended_search',
        'query_id': search_id,
        'page': page,
        'rows': rows,
        'sort': `${sort} nulls last`,
        // 'id_only': 1 // requests ID only (for refresh current search)
      }
// console.log('Search.extended_search() ', search_id, isUnsavedXml)
      if (search_id === 'new') {
        reqParams.xml = this._parseSearchToXml()
        reqParams.query_id = null
      }
      return this.api.call_busy(reqParams).then(response => {
        const items = []
        if (response && response.aitem) {
          if (!response.aitem.length) {
            response.aitem = [response.aitem]
          }
          for (let i in response.aitem) {
            items.push(new ContactModel().mapAitem(response.aitem[i]))
          }
          store.commit('setContactsTotal', parseInt(response._attributes.num, 10))
        } else {
          store.commit('setContactsTotal', 0)
        }
// console.log('extended_search: ', items.length)
        store.commit('setContactItems', items)
        return items
      })
    }
  }

  search_all({sort='name asc', page=0, rows=20}) {
    return this.api.call_busy({
      '_class': 'Search',
      '_method': 'extended_search',
      'xml': `<request>
  <search_block>
    <search id="id" type="field" operator="null-not"/>
  </search_block>
</request>`,
      'page': page,
      'rows': rows,
      'sort': `${sort} nulls last`,
      // 'id_only': 1 // requests ID only (for refresh current search)
    }).then(response => {
      const items = []
      if (response.aitem) {
        if (!response.aitem.length) {
          response.aitem = [response.aitem]
        }
        for (let i in response.aitem) {
          items.push(new ContactModel().mapAitem(response.aitem[i]))
        }
        store.commit('setContactsTotal', parseInt(response._attributes.num, 10))
      } else {
        store.commit('setContactsTotal', 0)
      }
      // console.log('search_all: ', items.length)
      store.commit('setContactItems', items)
      return items
    })
  }

  // loadGroup
  load_group(id) {
    return this.api.call_busy({
      '_class': 'Search',
      '_method': 'load_group',
      'id': id
    }).then(response => {
      let mGroup = new GroupModel()
      mGroup.name = response.query._attributes.name
      mGroup.count = response.mailings._attributes.count
      mGroup.item = id
      mGroup.own = (response.query._attributes.user_id == response._attributes.user_id) || store.getters.is_admin
      let contacts = response.search_result && response.search_result.aitem ? (response.search_result.aitem.length ? response.search_result.aitem : [response.search_result.aitem]) : []
      mGroup.contacts = contacts.map(a => ({value: a._attributes.id, text: this.search_text(a.fields)}))
      store.commit('setGroupItem', mGroup)
      return mGroup
    })
  }

  search_text(fields) {
    return [fields.name._text, fields.first_name._text, fields.company._text, fields.email._text].filter(Boolean).join(', ')
  }

  // autosuggest
  auto_suggest({search_string, rows=10, receives_newsletters=1}) {
    this.api.call_busy({
      '_class': 'Search',
      '_method': 'auto_suggest',
      'search_string': search_string,
      'rows': rows,
      'receives_newsletters': receives_newsletters
    }).then(response => {
      let entries = response.aitem ? (response.aitem.length ? response.aitem : [response.aitem]) : []
      entries = entries.map(a => ({
        value: a._attributes.id,
        // TODO: validation of missing data
        text: this.search_text(a.fields)
      }))
      store.commit('setQsEntries', entries)
    })
  }

  company_search(search_string) {
    this.api.call_oid({
      '_class': 'Search',
      '_method': 'company_search',
      'company': search_string,
    }).then(response => {
      if (response.company) {
        if (!response.company.length) {
          response.company = [response.company]
        }
        let companyItems = response.company.map( a => a._attributes.name)
        let activeContact = store.getters.activeContact
        if (activeContact['company']) {
          companyItems.unshift(activeContact['company'])
        }
        store.commit('setCompanyItems', companyItems)
      }
    })
  }


  search_pages({search_string, rows=50, lang_id=1, allowed_types}) {
    this.api.call_busy({
      '_class': 'Search',
      '_method': 'search_pages',
      'search_string': search_string,
      'rows': rows,
      'lang_id': lang_id,
      'allowed_types': allowed_types,
    }).then(response => {
      if (!response.item) {
        response.item = []
      } else
      if (!response.item.length) {
        response.item = [response.item]
      }
      const templates = response.item.map( a => a._attributes)
      const templatesFound = response._attributes.results
      //
      store.commit('setMailingTemplates', templates)
      store.commit('setTemplatesFound', templatesFound)
    })
  }


  // countSearchRecipients
  count(search_id) {
    this.api.call_busy({
      '_class': 'Search',
      '_method': 'count',
      'id': search_id,
    }).then(response => {
      if (!response.query) {
        response.query = []
      } else
      if (!response.query.length) {
        response.query = [response.query]
      }
      const searches = response.query.map(a => a._attributes)
      const mailing = store.getters.mailing

       mailing.recipients = mailing.recipients.map(a => {
         const foundSearch = searches.find(b => b.id === a.id)
         return foundSearch
           ? {...a, text: `${a.name} (${foundSearch.unique_count} | ${foundSearch.count})`}
           : a
       })

      const recipientsCount = {
        isLoading: false,
        show: true,
        unique: response._attributes.global_unique_count,
        all: response._attributes.global_count,
      }

      store.commit('setMailing', mailing)
      store.commit('setRecipientsCount', recipientsCount)

    })
  }


}